import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {RouterModule} from '@angular/router';
import {ReferenceSummaryTableModule} from './reference-summary-table/reference-summary-table.module';
import {ReferenceSummaryComponent} from './reference-summary.component';

@NgModule({
  imports: [
    MatButtonModule,
    MatIconModule,
    RouterModule,
    CommonModule,
    ReferenceSummaryTableModule,
    MatProgressSpinnerModule,
  ],
  declarations: [ReferenceSummaryComponent],
  exports: [ReferenceSummaryComponent],
})
export class ReferenceSummaryModule {}
